// extracted by mini-css-extract-plugin
export default {"section":"Menu_section__I5KKJ","navIcon":"Menu_navIcon__HM1od","menu":"Menu_menu__i31tW"};